var map = {
	"../admin/admin.module": "jkDv",
	"../home/home.module": "ct+p",
	"./all-reform-areas/all-reform-areas.module": "T9GS",
	"./coe/coe.module": "t0AT",
	"./financial/financial.module": "cvR4",
	"./hr/hr.module": "ZYlE",
	"./knowledge-expertise/knowledge-expertise.module": "WZ+9",
	"./management-stratgey/management-stratgey.module": "ik9d",
	"./menus/CSR-admin-page/csr-project.module": "U7nI",
	"./menus/blogs/blogs.module": "Boxu",
	"./menus/corporate/corporate.module": "wjIy",
	"./menus/events/events.module": "rE1k",
	"./menus/gallery/gallery.module": "cjvg",
	"./menus/incubatee/incubatee.module": "2OFP",
	"./menus/incubator-approval/incubator-approval.module": "QwAp",
	"./menus/newsletters/newsletters.module": "fHwg",
	"./network-ecosystem/network-ecosystem.module": "/+vb",
	"./physical-infrastructure/physical-infrastructure.module": "cbtV",
	"./pre-incubation/pre-incubation.module": "OsD5",
	"./result-outcome/result-outcome.module": "/Azh",
	"./social-impact/social-impact.module": "g9rR"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "zn8P";
module.exports = webpackAsyncContext;